/* eslint-disable camelcase */
import { useEffect, useReducer, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  setDateFormat,
  setLanguage,
  setNumberFormat} from "../Store/Reducers/generalSettings";
import { setUserDetails } from "../Store/Reducers/AuthModule/auth";

import { RootState } from "../Store/store";

import { fetchGeneralSettings } from "../Network/Core/generalSettings";

import { errorHandling } from "../Library/Utils";

import { IGeneralUserAction, IUserDetails } from "../types/generalSetings";

const useFetchGeneralSettings = () => {
  const initialUserDetails: IUserDetails = {
    company_details: {
      id: "",
      name: ""},
    general_settings: {
      id: "",
      time_zone: "",
      number_format: "en-US",
      date_format: "MM/DD/YYYY",
      default_language: "En",
      financial_year_start_month: "jan",
      financial_year_end_month: "dec"},
    success_manager: null,
    billing_information: {
      address_line_1: "",
      address_line_2: "",
      city: "",
      country: "",
      tax_id: "",
      vat_id: "",
      billing_contact_person: "",
      billing_email: ""}};

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [callUserDetails, setCallUserDetails] = useState<boolean>(false);

  const reducer = (userDetails: IUserDetails, action: IGeneralUserAction) => {
    switch (action.type) {
      case "updateCompanyDetails": {
        return {
          ...userDetails,
          company_details: {
            ...userDetails?.company_details,
            ...action.payload}};
      }
      case "updateGeneralSettings": {
        return {
          ...userDetails,
          general_settings: {
            ...userDetails?.general_settings,
            ...action.payload}};
      }
      case "updateSuccessManager": {
        return {
          ...userDetails,
          success_manager: {
            ...userDetails?.success_manager,
            ...action.payload}};
      }
      case "updateBillingInfo": {
        return {
          ...userDetails,
          billing_information: {
            ...userDetails?.billing_information,
            ...action.payload}};
      }
      case "updateUserInfo": {
        return {
          ...userDetails,
          ...action.payload};
      }
      default: {
        return userDetails;
      }
    }
  };

  const [userDetails, dispatch] = useReducer(reducer, initialUserDetails);
  const loggedInuserDetails = useSelector(
    (state: RootState) => state.authReducer.userDetails
  );

  const actionDispatch = useDispatch();

  const updateCompanyDetails = (payload: any) =>
    dispatch({ type: "updateCompanyDetails", payload });
  const updateGeneralSettingsInfo = (payload: any) =>
    dispatch({ type: "updateGeneralSettings", payload });
  const updateSuccessManager = (payload: any) =>
    dispatch({ type: "updateSuccessManager", payload });
  const updateBillingInformation = (payload: any) =>
    dispatch({ type: "updateBillingInfo", payload });
  const updateUserDetails = (payload: any) => {
    dispatch({ type: "updateUserInfo", payload });
    if (payload?.general_settings) {
      const { date_format, number_format, default_language } =
        payload.general_settings;
      actionDispatch(setDateFormat(date_format));
      actionDispatch(setNumberFormat(number_format));
      // actionDispatch(setLanguage(default_language));
      actionDispatch(
        setUserDetails({ company_name: payload?.company_details?.name })
      );
    }
  };

  const getGeneralSettingsInfo = async () => {
    try {
      setIsLoading(true);
      const res = await fetchGeneralSettings(loggedInuserDetails?.company_id);

      if (res?.data?.success) {
        if (res.data?.data?.general_settings) {
          updateUserDetails(res?.data?.data || {});
        }
      }
    } catch (e) {
      errorHandling(e);
    } finally {
      setIsLoading(false);
      setCallUserDetails(false);
    }
  };

  useEffect(() => {
    if (callUserDetails) getGeneralSettingsInfo();
  }, [callUserDetails]);

  useEffect(() => {
    if (loggedInuserDetails?.company_id && !callUserDetails) {
      setCallUserDetails(true);
    }
  }, [loggedInuserDetails?.company_id]);

  return {
    isLoading,
    setIsLoading,
    userDetails,
    setCallUserDetails,
    updateUserDetails,
    updateCompanyDetails,
    updateGeneralSettingsInfo,
    updateSuccessManager,
    updateBillingInformation};
};

export default useFetchGeneralSettings;
